export function protectBBCodeLiterals(text) {
    const stacks = { plain: [], literal: [], code: [], php: [] };
    const blocks = [];
    for (const tag of text.matchAll(/\[(\/?)\s*(plain|literal|code|php)(?:[=\s][^\]]*)?\]/gi)) {
        const stack = stacks[tag[2].toLowerCase()];
        if (!tag[1]) {
            stack.push({ start: tag.index, content: tag.index + tag[0].length });
        } else if (stack.length) {
            blocks.push({ ...stack.pop(), close: tag.index, end: tag.index + tag[0].length });
        }
    }

    let offset = 0;
    let result = '';
    // Complete outer blocks own their content, including nested literal tags.
    for (const block of blocks.sort((a, b) => a.start - b.start)) {
        if (block.start < offset) continue;
        // Entities preserve literal syntax through later BBCode and URL replacements.
        const content = text.slice(block.content, block.close)
            .replace(/[\[\]:"']/g, char => `&#${char.charCodeAt(0)};`);
        // The span keeps an outer YouTube tag from consuming literal content.
        result += text.slice(offset, block.start) + `<span>${content}</span>`;
        offset = block.end;
    }
    return result + text.slice(offset);
}
